import NewsPreview from "../react_components/news/news_preview";

export const NewsComponents = {
  NewsPreview,
};

